export enum OperationRecordType {
  editSetting,
  applyDeposit,
  collect,
  applyWithdraw,
  revokeOrder,
  executeWithdraw,
}
